<template>
  <h1 :class='headerClass'>
    {{ text }}
  </h1>
</template>

<script>
export default {
  name: 'report-header',
  props: {
    text: {
      required: true
    }
  },
  data: () => ({
    headerClass: 'mt-6 title font-weight-light text-uppercase',
  })
}
</script>